import { motion } from 'framer-motion';

/**
 * Animated background effects for the main lobby.
 * Renders floating translucent bingo balls and glowing blobs using pure CSS.
 */
export function BackgroundEffects() {
  const floatingBalls = [
    { num: 1, size: 80, top: '15%', left: '8%', delay: 0.2, duration: 6 },
    { num: 42, size: 100, bottom: '20%', left: '12%', delay: 0.5, duration: 8 },
    { num: 89, size: 70, top: '25%', right: '10%', delay: 0.8, duration: 5 },
    { num: 15, size: 90, bottom: '15%', right: '15%', delay: 0.1, duration: 7 },
  ];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none -z-10 bg-mesh bg-cover">
      {/* Glow Effects */}
      <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] rounded-full bg-blue-500/5 blur-[120px] animate-pulse" />
      <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] rounded-full bg-purple-500/5 blur-[120px] animate-pulse" />

      {/* Floating Translucent Balls */}
      {floatingBalls.map((ball, idx) => (
        <motion.div
          key={idx}
          initial={{ y: 0, opacity: 0 }}
          animate={{
            y: [-15, 15, -15],
            opacity: 0.12,
          }}
          transition={{
            y: {
              duration: ball.duration,
              repeat: Infinity,
              ease: 'easeInOut',
            },
            opacity: { duration: 1, delay: ball.delay },
          }}
          style={{
            width: ball.size,
            height: ball.size,
            top: ball.top,
            bottom: ball.bottom,
            left: ball.left,
            right: ball.right,
            background: 'radial-gradient(circle at 35% 35%, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.03) 50%, rgba(0,0,0,0.4) 100%)',
          }}
          className="absolute rounded-full border border-white/5 shadow-2xl flex items-center justify-center"
        >
          {/* Inner circle outline */}
          <div
            style={{ width: ball.size * 0.55, height: ball.size * 0.55 }}
            className="rounded-full border border-white/5 bg-white/2 flex items-center justify-center"
          >
            <span
              style={{ fontSize: ball.size * 0.24 }}
              className="font-display font-black text-white/20"
            >
              {ball.num}
            </span>
          </div>
        </motion.div>
      ))}

      {/* Fine ambient particles */}
      <div className="absolute inset-0 bg-[radial-gradient(rgba(255,255,255,0.02)_1px,transparent_1px)] [background-size:24px_24px] opacity-40" />
    </div>
  );
}
